import React from "react";
import { useSelector } from "react-redux";
import { selectLoggedIn } from "../store/userSlice/userSelectors";
import ConditionalRoute from "./ConditionalRoute";
import { PAGES_ENUM } from "../pages";
import { createURLPath } from "../helpers/urlBuilder";

const PrivateRoute = () => {
  const isLoggedIn = useSelector(selectLoggedIn);
  const currentPage = window.location.pathname + window.location.search + window.location.hash;
  const encoded = encodeURIComponent(currentPage);
  const props = {
    t: + new Date(),
    next: encoded,
  };

  const redirectTo = createURLPath({
    path: PAGES_ENUM.LOGIN_PAGE.path,
    queryObject: props,
  });

  return <ConditionalRoute condition={() => isLoggedIn} redirectTo={redirectTo} />
}

export default PrivateRoute;